/*! GW Wishlist v2.1 core | Godha World | vanilla JS, no jQuery | prefix gw- / GWWish
 *  Independent of GoKwik, AiSensy, checkout and the cart drawer. */
(function () {
  'use strict';
  if (window.GWWish) return;
  var W = window, D = document;
  var CFG = W.GW_WISHLIST_CONFIG || {};
  var KEY = 'gw_wishlist_v2', RKEY = 'gw_recent_v1', OKEY = 'gw_wl_optin_v1', CKEY = 'gw_pcache_v1', DKEY = 'gw_wl_drops_v1';

  function $(s, r) { return (r || D).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function read(k, d) { try { var v = JSON.parse(localStorage.getItem(k)); return v == null ? d : v; } catch (e) { return d; } }
  function write(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  var CURRENCY = (W.Shopify && W.Shopify.currency && W.Shopify.currency.active) || 'INR';
  var nf = null;
  try { nf = new Intl.NumberFormat('en-IN', { style: 'currency', currency: CURRENCY, maximumFractionDigits: 0 }); } catch (e) {}
  function money(c) { return nf ? nf.format(c / 100) : '\u20B9' + Math.round(c / 100); }
  function img(u, w) { if (!u) return ''; if (u.indexOf('//') === 0) u = 'https:' + u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';

  /* ---------- storage ---------- */
  function load() {
    var l = read(KEY, null);
    if (!Array.isArray(l)) {
      l = [];
      var old = read('wbwishtems', []);
      if (Array.isArray(old)) old.forEach(function (h, i) { if (typeof h === 'string' && h) l.push({ h: h, t: Date.now() - i, p: null }); });
      if (l.length) write(KEY, l);
    }
    return l.filter(function (x) { return x && x.h; });
  }
  var list = load();
  function save() { write(KEY, list); }
  function idx(h) { for (var i = 0; i < list.length; i++) if (list[i].h === h) return i; return -1; }
  function has(h) { return idx(h) > -1; }
  function handles() { return list.map(function (x) { return x.h; }); }

  /* ---------- product data ---------- */
  var mem = {}, pool = {};
  function norm(p, isJs) {
    var vs = (p.variants || []).map(function (v) {
      return { id: v.id, title: v.title, available: !!v.available,
        price: isJs ? v.price : Math.round(parseFloat(v.price) * 100),
        compare: v.compare_at_price ? (isJs ? v.compare_at_price : Math.round(parseFloat(v.compare_at_price) * 100)) : 0 };
    });
    var f = vs.filter(function (v) { return v.available; })[0] || vs[0] || { price: 0, compare: 0 };
    var image = isJs ? (p.featured_image || '') : ((p.images && p.images[0] && p.images[0].src) || '');
    var tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(/,\s*/);
    return { id: p.id, handle: p.handle, title: p.title, url: '/products/' + p.handle, price: f.price, compare: f.compare,
      available: vs.some(function (v) { return v.available; }), image: image, tags: tags, variants: vs };
  }
  function getProduct(h) {
    if (mem[h]) return mem[h];
    var c = read(CKEY, {}), hit = c[h];
    if (hit && Date.now() - hit.t < 600000) { mem[h] = Promise.resolve(hit.p); return mem[h]; }
    mem[h] = fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (j) {
        var p = norm(j, true), cc = read(CKEY, {});
        cc[h] = { t: Date.now(), p: p };
        var ks = Object.keys(cc);
        if (ks.length > 60) ks.sort(function (a, b) { return cc[a].t - cc[b].t; }).slice(0, ks.length - 60).forEach(function (k) { delete cc[k]; });
        write(CKEY, cc);
        return p;
      }).catch(function () { delete mem[h]; return null; });
    return mem[h];
  }
  function getMany(hs) { return Promise.all(hs.map(getProduct)).then(function (a) { return a.filter(Boolean); }); }

  /* ---------- tracking (GTM dataLayer + Meta pixel); no personal data ---------- */
  function track(ev, h, price) {
    var val = price ? price / 100 : undefined;
    try { (W.dataLayer = W.dataLayer || []).push({ event: ev, ecommerce: { currency: CURRENCY, value: val, items: [{ item_id: h, item_name: h, price: val }] } }); } catch (e) {}
    try { if (ev === 'add_to_wishlist' && typeof W.fbq === 'function') W.fbq('track', 'AddToWishlist', { content_ids: [h], content_type: 'product', currency: CURRENCY, value: val || 0 }); } catch (e) {}
  }

  /* ---------- mutations ---------- */
  function emit() { D.dispatchEvent(new CustomEvent('gw:wishlist', { detail: { count: list.length, handles: handles() } })); }
  function add(h) {
    if (has(h)) return;
    list.unshift({ h: h, t: Date.now(), p: null }); save(); emit(); track('add_to_wishlist', h, null);
    getProduct(h).then(function (pr) { var i = idx(h); if (pr && i > -1 && list[i].p == null) { list[i].p = pr.price; save(); } });
  }
  function remove(h) { var i = idx(h); if (i < 0) return null; var it = list.splice(i, 1)[0]; save(); emit(); return it; }

  /* ---------- hearts ---------- */
  function btn(h, kind) {
    var b = D.createElement('button');
    b.type = 'button'; b.className = 'gw-wish-btn gw-wish-btn--' + kind; b.setAttribute('data-gw-handle', h);
    b.innerHTML = HEART + (kind === 'pdp' ? '<span class="gw-wish-label"></span>' : '');
    paint(b); return b;
  }
  function paint(b) {
    var on = has(b.getAttribute('data-gw-handle'));
    b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    var t = on ? 'Remove from wishlist' : 'Add to wishlist'; b.setAttribute('aria-label', t); b.title = t;
    var l = $('.gw-wish-label', b); if (l) l.textContent = on ? 'Saved to wishlist' : 'Add to wishlist';
  }
  function setCount() {
    var n = list.length, d = read(DKEY, null), drop = !!(d && d.n > 0 && n > 0);
    $$('.wbwishcount').forEach(function (el) {
      if (el.textContent !== String(n)) el.textContent = n;
      var a = el.closest('a');
      if (a) {
        if (a.getAttribute('data-gw-wired') !== '1') { a.setAttribute('href', '/pages/wishlist'); a.setAttribute('data-gw-wired', '1'); }
        a.setAttribute('aria-label', 'Wishlist (' + n + ')'); a.classList.toggle('gw-has-drop', drop);
      }
    });
    $$('[data-gw-count]').forEach(function (el) { if (el.textContent !== String(n)) el.textContent = n; });
  }
  function paintAll() { $$('.gw-wish-btn').forEach(paint); setCount(); }
  function hFromHref(href) { var m = (href || '').match(/\/products\/([^\/?#]+)/); return m ? decodeURIComponent(m[1]) : null; }
  function decorate() {
    $$('.card-wrapper, .gw-sc__card').forEach(function (card) {
      if (card.hasAttribute('data-gw-wish') || card.closest('[data-gw-wish]') || card.closest('#gw-wishlist-root') || card.closest('#gwp')) return;
      var a = $('a[href*="/products/"]', card), h = a && hFromHref(a.getAttribute('href'));
      if (!h) return;
      var host = $('.card__inner', card) || card;
      card.setAttribute('data-gw-wish', '1'); host.classList.add('gw-wish-host'); host.appendChild(btn(h, 'card'));
    });
    decoratePdp();
  }
  function decoratePdp() {
    if (!/template-product/.test(D.body.className) || $('.gw-wish-btn--pdp')) return;
    var m = location.pathname.match(/\/products\/([^\/?#]+)/); if (!m) return;
    var main = $('#MainContent') || D;
    var form = $('product-form form[action*="/cart/add"], form[action*="/cart/add"]', main);
    var submit = form && $('.product-form__submit, [type="submit"]', form); if (!submit) return;
    var anchor = submit.closest('.product-form__buttons') || submit.parentElement;
    anchor.parentNode.insertBefore(btn(decodeURIComponent(m[1]), 'pdp'), anchor.nextSibling);
  }

  /* ---------- toast: one at a time, pauses while touched, longer when it has an action, silent behind the cart drawer ---------- */
  var toastEl, toastT, toastHold = false;
  function arm(ms) { clearTimeout(toastT); if (!toastHold) toastT = setTimeout(hideToast, ms); }
  function toast(msg, label, fn, href) {
    var cd = D.querySelector('cart-drawer');
    if (cd && cd.classList.contains('active')) return;
    if (!toastEl) {
      toastEl = D.createElement('div'); toastEl.className = 'gw-toast'; toastEl.setAttribute('role', 'status'); toastEl.setAttribute('aria-live', 'polite'); toastEl.setAttribute('aria-atomic', 'true');
      D.body.appendChild(toastEl);
      ['pointerdown', 'focusin', 'mouseenter'].forEach(function (ev) { toastEl.addEventListener(ev, function () { toastHold = true; clearTimeout(toastT); }); });
      ['pointerup', 'pointercancel', 'focusout', 'mouseleave'].forEach(function (ev) { toastEl.addEventListener(ev, function () { toastHold = false; arm(2500); }); });
    }
    toastHold = false;
    toastEl.innerHTML = '<span class="gw-toast__msg">' + esc(msg) + '</span>';
    if (label) {
      var a = D.createElement(href ? 'a' : 'button'); a.className = 'gw-toast__act'; a.textContent = label;
      if (href) a.href = href; else { a.type = 'button'; a.addEventListener('click', function () { if (fn) fn(); hideToast(); }); }
      toastEl.appendChild(a);
    }
    toastEl.classList.add('is-on'); arm(label ? 6500 : 4000);
  }
  function hideToast() { if (toastEl) toastEl.classList.remove('is-on'); }

  D.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.gw-wish-btn'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var h = b.getAttribute('data-gw-handle'); if (!h) return;
    b.classList.add('gw-pop'); setTimeout(function () { b.classList.remove('gw-pop'); }, 400);
    if (has(h)) {
      var it = remove(h);
      toast('Removed from wishlist', 'Undo', function () { if (it && !has(h)) { list.unshift(it); save(); emit(); } });
    } else {
      add(h); toast('Saved to your wishlist', 'View', null, '/pages/wishlist');
    }
  }, true);

  function shareUrl(hs) {
    hs = (hs || handles()).slice(0, 25);
    return location.origin + '/pages/wishlist?items=' + hs.map(encodeURIComponent).join(',') + '&utm_source=wishlist_share';
  }

  /* ---------- cart: plain Shopify Ajax API, no theme/GoKwik hooks ---------- */
  function addToCart(items) {
    return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); });
  }
  function refreshCart() {
    return fetch('/?sections=cart-icon-bubble', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
      var html = j && j['cart-icon-bubble']; if (!html) return;
      var tmp = D.createElement('div'); tmp.innerHTML = html;
      var src = $('.shopify-section', tmp) || tmp, dst = $('#cart-icon-bubble');
      if (dst) dst.innerHTML = src.innerHTML;
    }).catch(function () {});
  }

  /* ---------- recently viewed + price-drop check ---------- */
  function trackView() {
    if (!/template-product/.test(D.body.className)) return;
    var m = location.pathname.match(/\/products\/([^\/?#]+)/); if (!m) return;
    var h = decodeURIComponent(m[1]), r = read(RKEY, []).filter(function (x) { return x !== h; });
    r.unshift(h); write(RKEY, r.slice(0, 20));
  }
  function checkDrops() {
    if (!list.length) return;
    var d = read(DKEY, null); if (d && Date.now() - d.t < 6 * 3600 * 1000) return;
    getMany(handles().slice(0, 15)).then(function (ps) {
      var n = 0, map = {};
      ps.forEach(function (p) {
        var i = idx(p.handle); if (i < 0) return;
        var saved = list[i].p;
        if (saved == null) { list[i].p = p.price; return; }
        if (p.price < saved) { n++; map[p.handle] = { from: saved, to: p.price }; }
      });
      save(); write(DKEY, { t: Date.now(), n: n, map: map }); setCount();
    });
  }

  /* ---------- optional WhatsApp opt-in sync (dormant unless a webhook is configured) ---------- */
  function normPhone(v) {
    var s = String(v || '').trim(), plus = s.charAt(0) === '+', d = s.replace(/\D/g, '');
    if (plus) return d.length >= 11 && d.length <= 15 ? '+' + d : '';
    if (d.length === 10 && /^[6-9]/.test(d)) return '+91' + d;
    if (d.length === 11 && d.charAt(0) === '0' && /^[6-9]/.test(d.charAt(1))) return '+91' + d.slice(1);
    if (d.length === 12 && d.slice(0, 2) === '91' && /^[6-9]/.test(d.charAt(2))) return '+' + d;
    return '';
  }
  var syncT;
  function scheduleSync() { if (!CFG.webhook || !read(OKEY, null)) return; clearTimeout(syncT); syncT = setTimeout(function () { sendSync('wishlist_updated'); }, 15000); }
  function sendSync(evt, optOverride) {
    var o = optOverride || read(OKEY, null), url = CFG.webhook;
    if (!url || !o || !o.phone) return Promise.resolve();
    return getMany(handles().slice(0, 10)).then(function (ps) {
      var top = ps[0], drops = read(DKEY, null) || {};
      var payload = {
        event: evt, event_id: 'gw' + Date.now() + Math.random().toString(36).slice(2, 7), source: 'godhaworld_wishlist',
        consent_whatsapp: evt === 'wishlist_optout' ? 'no' : 'yes', consent_text: CFG.consentText || '', consent_at: o.ts || '',
        phone: o.phone, name: o.name || '', customer_id: String(CFG.customerId || ''),
        wishlist_count: String(list.length), wishlist_items: ps.map(function (p) { return p.title; }).join(' | ').slice(0, 900),
        wishlist_handles: handles().join(','), top_item_title: top ? top.title : '', top_item_url: top ? location.origin + top.url : '',
        top_item_price: top ? String(Math.round(top.price / 100)) : '', wishlist_url: shareUrl(), price_drop_count: String(drops.n || 0),
        shop: location.hostname, ts: new Date().toISOString()
      };
      return fetch(url, { method: 'POST', mode: 'no-cors', keepalive: true, headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: JSON.stringify(payload) });
    }).catch(function () {});
  }

  /* ---------- boot ---------- */
  var G = { CFG: CFG, KEYS: { R: RKEY, O: OKEY }, list: list, $: $, $$: $$, esc: esc, read: read, write: write, money: money, img: img, HEART: HEART,
    idx: idx, has: has, handles: handles, add: add, remove: remove, save: save, emit: emit, getMany: getMany, norm: norm, pool: pool,
    toast: toast, shareUrl: shareUrl, addToCart: addToCart, refreshCart: refreshCart, normPhone: normPhone, sendSync: sendSync, paintAll: paintAll,
    pageRender: null, initPage: null };
  W.GWWishInternal = G;
  W.GWWish = { has: has, add: add, remove: remove, count: function () { return list.length; }, handles: handles };
  var dt;
  function boot() {
    trackView(); decorate(); setCount();
    (W.requestIdleCallback || function (f) { setTimeout(f, 3000); })(checkDrops);
    if ('MutationObserver' in W) new MutationObserver(function () { clearTimeout(dt); dt = setTimeout(function () { decorate(); setCount(); }, 200); }).observe(D.body, { childList: true, subtree: true });
  }
  D.addEventListener('gw:wishlist', function () { paintAll(); scheduleSync(); });
  W.addEventListener('storage', function (e) { if (e.key === KEY) { list.length = 0; Array.prototype.push.apply(list, load()); paintAll(); if (G.pageRender) G.pageRender(); } });
  W.addEventListener('load', setCount);
  D.addEventListener('shopify:section:load', function () { decorate(); setCount(); });
  if (D.readyState === 'complete') boot(); else D.addEventListener('DOMContentLoaded', boot);
})();